import { getVendors } from "../../store/AsyncMethods/VendorMethod";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { RESET_SPECIFIC_CATEGORIES } from "../../store/Types/CategoryTypes";
import { useTranslation } from "react-i18next";
import { Dropdown } from "primereact/dropdown";
import * as Yup from "yup";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Icons, toast } from "react-toastify";
import { Divider } from "primereact/divider";

import { getCurrency } from "../../store/AsyncMethods/CurrencyMethod";
import { SelectButton } from "primereact/selectbutton";
import {
  getPurchase,
  getspecificPurchase,
} from "../../store/AsyncMethods/PurchaseMethod";
import { Calendar } from "primereact/calendar";
import { addCashReceipt } from "../../store/AsyncMethods/CashReceiptMethod";
import { getspecificVendor } from "../../store/AsyncMethods/VendorMethod";

export default function PurchaseReceipt() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { allVendors } = useSelector((state) => state.VendorReducer);
  const { allCurrency } = useSelector((state) => state.CurrencyReducer);
  const { allPurchases } = useSelector((state) => state.PurchaseReducer);
  const { specificPurchase } = useSelector((state) => state.PurchaseReducer);
  const { success, error, user } = useSelector((state) => state.AuthReducer);
  const navigate = useNavigate();
  const { vendorId } = useParams();
  const { specificVendor } = useSelector((state) => state.VendorReducer);

  const receiptTypes = [
    { name: t("Cash"), id: 1 },
    { name: t("Return"), id: 2 },
  ];

  const formik = useFormik({
    initialValues: {
      receiptType: 1,
      description: "",
      vendor: "",
      balance: "",
      amount: "",
      total: "",
      currency: 5,
      invoice: "",
      posted: 0,
      name: "",
      date: new Date(),
      originalRemainingAmount: "",
      type: 2, // Set to 2 for Purchase
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name Required"),
      balance: Yup.string().required("Balance Required"),
      receiptType: Yup.string().required("Type Required"),
      date: Yup.string().required("Transaction Date Required"),
      amount: Yup.string().required("Amount Required"),
      currency: Yup.string().required("Currency Required"),
      invoice: Yup.string().required("Invoice Required"),
    }),

    onSubmit: async (data) => {
      const submissionData = {
        ...data,
        amount: data.originalRemainingAmount
          ? (
              parseFloat(data.originalRemainingAmount) -
              parseFloat(data.balance)
            ).toString()
          : data.amount,
      };

      dispatch(addCashReceipt(submissionData)).then((success) => {
        if (success) {
          formik.resetForm();
        }
      });
    },
  });

  useEffect(() => {
    if (specificVendor) {
      formik.setValues({
        ...formik.values,
        name: specificVendor.name || "",
        balance: specificVendor.vendor_balance || "",
      });
    }
  }, [specificVendor]);

  useEffect(() => {
    if (specificPurchase) {
      formik.setValues({
        ...formik.values,
        amount: specificPurchase.remain_amount || "",
        total: specificPurchase.total || "",
        originalRemainingAmount: specificPurchase.remain_amount || "",
      });
    }
  }, [specificPurchase]);

  useEffect(() => {
    if (formik.values.vendor) dispatch(getspecificVendor(formik.values.vendor));
  }, [formik.values.vendor]);

  useEffect(() => {
    if (formik.values.invoice) {
      dispatch(getspecificPurchase(formik.values.invoice));
    }
  }, [formik.values.invoice]);

  useEffect(() => {
    dispatch(getVendors());
    dispatch(getCurrency());
    dispatch(getPurchase());
  }, []);

  const handleBalanceChange = (e) => {
    const balance = parseFloat(e.target.value) || 0;
    const originalRemaining =
      parseFloat(formik.values.originalRemainingAmount) || 0;

    const newRemainingAmount = originalRemaining - balance;

    formik.setValues({
      ...formik.values,
      balance: e.target.value,
      amount: newRemainingAmount.toString(),
    });
  };

  return (
    <div className="mx-4">
      <form onSubmit={formik.handleSubmit}>
        <div className="card shadow-md rounded-lg p-4 mt-3">
          <Divider>
            <span className="text-2xl font-bold p-font-style text-center text-primary mx-1">
              {t("AP Receipt")}
            </span>
          </Divider>

          <div className="px-4 gap-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            <div className="">
              <div className="flex flex-col gap-2">
                <label htmlFor="receiptType" className="">
                  {t("Receipt Type")}
                </label>

                <Dropdown
                  id="receiptType"
                  name="receiptType"
                  className="!w-full text-lg p-primary-input"
                  value={formik.values.receiptType}
                  onChange={formik.handleChange}
                  options={receiptTypes}
                  optionLabel="name"
                  optionValue="id"
                  pt={{
                    root: { className: "w-full" },
                    input: { className: "w-full p-primary-input" },
                    filterIcon: { className: "ml-2" },
                    filterInput: { className: "pl-8" },
                  }}
                />
              </div>
              {formik.touched?.receiptType && formik.errors?.receiptType && (
                <div className="p-error">{formik.errors?.receiptType}</div>
              )}
            </div>

            <div className="">
              <div className="flex flex-col gap-2">
                <label htmlFor="currency" className="">
                  {t("Select Currency")}
                </label>

                <Dropdown
                  id="currency"
                  name="currency"
                  className="!w-full text-lg p-primary-input"
                  value={formik.values.currency}
                  onChange={formik.handleChange}
                  options={allCurrency}
                  optionLabel="name"
                  optionValue="id"
                  filter
                  pt={{
                    root: { className: "w-full" },
                    input: { className: "w-full p-primary-input" },
                    filterIcon: { className: "ml-2" },
                    filterInput: { className: "pl-8" },
                  }}
                />
              </div>
              {formik.touched?.currency && formik.errors?.currency && (
                <div className="p-error">{formik.errors?.currency}</div>
              )}
            </div>

            <div className=" ">
              <div className="flex flex-col  gap-2  p-fluid">
                <label htmlFor="date" className="">
                  {t("trans_date")}
                </label>

                <Calendar
                  dateFormat="yy/mm/dd"
                  id="date"
                  onChange={formik.handleChange}
                  className=" w-full calender p-primary-cld-btn"
                  value={formik.values.date}
                  showIcon
                />
              </div>
              {formik.touched?.date && formik.errors?.date && (
                <div className="p-error">{formik.errors?.date}</div>
              )}
            </div>

            {/* <div className="">
              <div className="flex flex-col gap-2">
                <label htmlFor="description" className="">
                  {t("description")}
                </label>
                <span className=" w-full">
                  <InputText
                    id="description"
                    name="description"
                    className="w-full text-lg p-primary-input"
                    value={formik.values.description}
                    onChange={formik.handleChange}
                  />
                </span>
              </div>
              {formik.touched?.description && formik.errors?.description && (
                <div className="p-error">{formik.errors?.description}</div>
              )}
            </div> */}

            <div className="">
              <div className="flex flex-col gap-2">
                <label htmlFor="vendor" className="">
                  {t("Select Vendor")}
                </label>

                <Dropdown
                  id="vendor"
                  name="vendor"
                  className="!w-full text-lg p-primary-input"
                  value={formik.values.vendor}
                  onChange={formik.handleChange}
                  options={allVendors}
                  optionLabel="name"
                  optionValue="id"
                  filter
                  pt={{
                    root: { className: "w-full" },
                    input: { className: "w-full p-primary-input" },
                    filterIcon: { className: "ml-2" },
                    filterInput: { className: "pl-8" },
                  }}
                />
              </div>
              {formik.touched?.vendor && formik.errors?.vendor && (
                <div className="p-error">{formik.errors?.vendor}</div>
              )}
            </div>

            <div className="">
              <div className="flex flex-col gap-2">
                <label htmlFor="name" className="">
                  {t("vendor_name")}*
                </label>
                <span className=" flex gap-2 w-full">
                  <InputText
                    id="name"
                    name="name"
                    className="w-full text-lg p-primary-input"
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    disabled
                  />
                </span>
              </div>
              {formik.touched?.name && formik.errors?.name && (
                <div className="p-error">{formik.errors?.name}</div>
              )}
            </div>

            <div className="">
              <div className="flex flex-col gap-2">
                <label htmlFor="balance" className="">
                  {t("vendor_balance")}*
                </label>
                <span className=" flex gap-2 w-full">
                  <InputText
                    id="balance"
                    name="balance"
                    className="w-full text-lg p-primary-input"
                    value={formik.values.balance}
                    onChange={handleBalanceChange}
                  />
                </span>
              </div>
              {formik.touched?.balance && formik.errors?.balance && (
                <div className="p-error">{formik.errors?.balance}</div>
              )}
            </div>

            <div className="">
              <div className="flex flex-col gap-2">
                <label htmlFor="invoice" className="">
                  {t("Select Invoice")}
                </label>

                <Dropdown
                  id="invoice"
                  name="invoice"
                  className="!w-full text-lg p-primary-input"
                  value={formik.values.invoice}
                  onChange={formik.handleChange}
                  options={allPurchases}
                  optionLabel={(option) =>
                    `(${option.id}) - ${new Date(option.created_at)}`
                  }
                  optionValue="id"
                  filter
                  pt={{
                    root: { className: "w-full" },
                    input: { className: "w-full p-primary-input" },
                    filterIcon: { className: "ml-2" },
                    filterInput: { className: "pl-8" },
                  }}
                />
              </div>
              {formik.touched?.invoice && formik.errors?.invoice && (
                <div className="p-error">{formik.errors?.invoice}</div>
              )}
            </div>

            <div className="">
              <div className="flex flex-col gap-2">
                <label htmlFor="amount" className="">
                  Remaining Amount
                </label>
                <span className=" flex gap-2 w-full">
                  <InputText
                    id="amount"
                    name="amount"
                    className="w-full text-lg p-primary-input"
                    value={formik.values.amount}
                    onChange={formik.handleChange}
                    disabled
                  />
                </span>
              </div>
              {formik.touched?.amount && formik.errors?.amount && (
                <div className="p-error">{formik.errors?.amount}</div>
              )}
            </div>

            <div className="">
              <div className="flex flex-col gap-2">
                <label htmlFor="amount" className="">
                  {t("total_amount")}*
                </label>
                <span className=" flex gap-2 w-full">
                  <InputText
                    id="total_amount"
                    name="total_amount"
                    className="w-full text-lg p-primary-input"
                    value={formik.values.total}
                    onChange={formik.handleChange}
                    disabled
                  />
                </span>
              </div>
              {formik.touched?.amount && formik.errors?.amount && (
                <div className="p-error">{formik.errors?.amount}</div>
              )}
            </div>
          </div>
        </div>

        <div className="mt-8">
          <div className="flex justify-end gap-4">
            <Button
              label={t("cancel")}
              icon="pi pi-times"
              className="p-red-btn"
              type="button"
              onClick={() => {
                formik.resetForm();
              }}
            />
            <Button
              label={t("submit")}
              icon="pi pi-check"
              className="p-secondary-btn"
              type="submit"
            />
            <Button
              label={t("post")}
              icon="pi pi-check"
              className="p-primary-btn"
              type="submit"
              onClick={() => {
                formik.values.posted = 1;
              }}
            />
          </div>
        </div>
      </form>
    </div>
  );
}
